import { clsx } from 'clsx'
import { CSSProperties, ReactNode } from 'react'
import { getLineHeight, styles } from 'util/style'
import css from './Typo.module.scss'

type Props = {
  accent?: boolean
  balance?: boolean
  bold?: boolean
  center?: boolean
  children?: ReactNode
  clamp?: boolean
  className?: string
  code?: boolean
  dotted?: boolean
  ellipsis?: boolean
  error?: boolean
  first?: boolean
  letter?: number
  line?: number
  medium?: boolean
  mono?: boolean
  normal?: boolean
  nowrap?: boolean
  one?: boolean
  pre?: boolean
  primary?: boolean
  secondary?: boolean
  semi?: boolean
  size?: number
  style?: CSSProperties
  tertiary?: boolean
  title?: string
  upper?: boolean
  lower?: boolean
  weight?: number
  wrap?: boolean
}

export function Typo(props: Props) {
  const {
    accent, balance, bold, center, children, code, ellipsis, error, first,
    dotted, letter, line, medium, mono, normal, nowrap, one,
    pre, primary, secondary, semi, size, tertiary, title, upper, lower, weight, wrap, clamp,
  } = props

  const className = clsx(
    props.className,
    css.typo,
    accent ? 'font-accent' : 'font-regular',
    medium && css.medium,
    semi && css.semi,
    bold && css.bold,
    mono && css.mono,
    dotted && css.dotted,
    center && css.center,
    one && css.one,
    upper && css.upper,
    lower && css.lower,
    code && css.code,
    pre && css.pre,
    normal && css.normal,
    nowrap && css.nowrap,
    wrap && css.wrap,
    balance && css.balance,
    primary && css.primary,
    ellipsis && css.ellipsis,
    error && css.error,
    first && css.first,
    secondary && css.secondary,
    tertiary && css.tertiary,
    clamp && css.clamp,
  )

  const fontSize = size
  const fontWeight = weight
  const lineHeight = getLineHeight(line)
  const letterSpacing = letter ? letter + 'px' : undefined
  const style = styles({ fontSize, fontWeight, lineHeight, letterSpacing, ...props.style })

  return <span className={className} style={style} title={title}>
    {children}
  </span>
}
